import {fetchHelper} from '../helpers/request_helper';
import {CREATE_LPL_URL} from '../constants/api_paths';
import store from '../store';

const SUMMARY_URL = process.env.REACT_APP_SUMMARY_URL;

export function openSummary() {
    const user = store.getState().userInfo.data;
    if (!user) return Promise.reject('No user');    
    const deviceHash = localStorage.getItem("mdrcma") || '';
    return fetchHelper.callPost(CREATE_LPL_URL, {}, false, {app: 'medrec-m', device_hash: deviceHash}).then(lpl => {
        window.open(`${SUMMARY_URL}?lpl=${encodeURIComponent(lpl)}&client=medrec-m-clinic`, '_blank');
    }).catch(err => {
        console.error('Failed to create LPL token', err);
    });
}